import { useState, useContext } from 'react';
import { IonContent, IonPage, IonGrid, IonRow, IonCol, IonInput, IonButton, useIonViewDidEnter } from '@ionic/react';
import Navbar from '../../components/Navbar';
import './styles.css';
import axios from 'axios';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  const isEscWorks = CurrentUser ? CurrentUser.isEscWorks : false;
  const groupName = CurrentUser ? CurrentUser.group : '';

  const currentYear = GetCurrentYear() - 2000;
  let current_year = currentYear + '-' + (currentYear + 1);
  let previous_year = (currentYear - 1) + '-' + currentYear;

  const currentFullYear = GetCurrentYear();
  let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
  let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

  const dataUrl = `${ServerUrl}/annually/7.3`;

  const [CurrentData, SetCurrentData] = useState<Array<any>>([]);
  const [PreviousData, SetPreviousData] = useState<Array<any>>([]);

  useIonViewDidEnter(() => {
    console.log('ionViewDidEnter event fired');
    LoadData();
  });

  const LoadData = () => {
    axios.get(`${dataUrl}?year=${current_year}`, {
        headers: {
          'Authorization': "Bearer " + token,          
        }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          SetCurrentData(res.data);
        }
    }, err => {
      console.log("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${dataUrl}?year=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetPreviousData(res.data);
      }
  }, err => {
    console.log("Fail to get data. " + JSON.stringify(err))
  });
  };

  const getData = (dataArray: Array<any>, quater: string, name: string) => {
    let num = 0;
    let element = dataArray.find(e => e.quater === quater);
    if (element) {
        num = parseFloat(element[name]);
    }
    return num;
  }

  const saveData = (year: string, quater: string, name: string, value: any) => {
    axios.post(dataUrl, {"year": year, "quater": quater, "name": name, "value": value}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (year === current_year) {
        SetCurrentData(res.data);
      } else {
        SetPreviousData(res.data);
      }
    }, err => console.log("error"));
  }

  const onSaveExcel = () => {
    axios.get(`${dataUrl}/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','Annual 7.3.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
          <div className='content-container'>
            <div style={{marginBottom: '10px', marginTop: '20px'}}>{groupName}</div>
            <div style={{marginBottom: '20px'}}>Indicator 7.3 - Number of Partnerships among ESCs and with External Entities </div>
            <IonButton color="primary" style={{textTransform:'none'}} onClick = {onSaveExcel}>Export to Excel</IonButton>
          </div>
          <div className='flex-container'>
            <div style={{flexGrow: '1'}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="5" size="5" className='right-border bottom-border table-header'>
                    <IonInput min='0'  value={current_full_year} readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row" style={{minHeight: '60px'}}>
                  <IonCol size="3" className='no-border'></IonCol>
                  <IonCol size="4" className='no-border'>ESCs</IonCol>
                  <IonCol size="1" className='no-border'></IonCol>
                  <IonCol size="4" className='no-border'>External Entities</IonCol>
                </IonRow>

                    <div style={{display: 'flex'}} >
                      <IonCol size="3" className='data-row no-border'>{'# of Partnerships'}</IonCol>
                      <IonCol size="4" className='data-row right-border'>
                        {isEscWorks && <IonInput min='0'  type="number" step="1" value={getData(CurrentData, "Partnerships", 'esc')} placeholder="" onBlur={(e) => {
                             saveData(current_year, "Partnerships", "esc", e.target.value)
                            }}>     
                        </IonInput>}
                        {!isEscWorks && <IonInput min='0'  readonly type="number" step="1" value={getData(CurrentData, "Partnerships", 'esc')} placeholder="">     
                        </IonInput>}
                      </IonCol>
                      <IonCol size="1" className='data-row no-border'></IonCol>
                      <IonCol size="4" className='data-row right-border'>
                        {isEscWorks && <IonInput min='0'  type="number" step="1" value={getData(CurrentData, "Partnerships", 'externalEntity')} placeholder="" onBlur={(e) => {
                             saveData(current_year, "Partnerships", "externalentity", e.target.value)
                            }}>     
                        </IonInput>}
                        {!isEscWorks && <IonInput min='0'  readonly type="number" step="1" value={getData(CurrentData, "Partnerships", 'externalEntity')} placeholder="">     
                        </IonInput>}
                      </IonCol>
                    </div>

                <IonRow>
                  <IonCol size="3" className='no-border'></IonCol>
                  <IonCol size="4" className='top-border'></IonCol>
                  <IonCol size="1" className='no-border'></IonCol>
                  <IonCol size="4" className='top-border'></IonCol>
                </IonRow>
              </IonGrid>
            </div>
            <div style={{flexGrow: '1'}}>
              <IonGrid>
                <IonRow>
                  <IonCol offset="5" size="5" className='right-border bottom-border table-header'>
                    <IonInput min='0'  value={previous_full_year} readonly />
                  </IonCol>
                </IonRow>
                <IonRow className="header-row" style={{minHeight: '60px'}}>
                  <IonCol size="3" className='no-border'></IonCol>
                  <IonCol size="4" className='no-border'>ESCs</IonCol>
                  <IonCol size="1" className='no-border'></IonCol>
                  <IonCol size="4" className='no-border'>External Entities</IonCol>
                </IonRow>

                    <div style={{display: 'flex'}} >
                      <IonCol size="3" className='data-row no-border'>{'# of Partnerships'}</IonCol>
                      <IonCol size="4" className='data-row right-border'>
                        <IonInput min='0'  readonly  type="number" step="1" value={getData(PreviousData, "Partnerships", 'esc')} placeholder="" onBlur={(e) => {
                             saveData(previous_year, "Partnerships", "esc", e.target.value)
                            }}>     
                        </IonInput>
                      </IonCol>
                      <IonCol size="1" className='data-row no-border'></IonCol>
                      <IonCol size="4" className='data-row right-border'>
                        <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousData, "Partnerships", 'externalEntity')} placeholder="" onBlur={(e) => {
                             saveData(previous_year, "Partnerships", "externalentity", e.target.value)
                            }}>     
                        </IonInput>               
                      </IonCol>
                    </div>

                <IonRow>
                  <IonCol size="3" className='no-border'></IonCol>
                  <IonCol size="4" className='top-border'></IonCol>
                  <IonCol size="1" className='no-border'></IonCol>
                  <IonCol size="4" className='top-border'></IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </div>

      </IonContent>
    </IonPage>
  );
};

export default Home;
